<template>
    <!-- DESCR：会议登录页 -->
    <div class="conferencelogin-container">
        <!-- 页面信息描述 -->
        <el-row justify="center">
            <el-col :span="21" class="login-title">
                <div class="desc-box">
                    <div class="title">{{ $route.query.acronym }} ({{ $route.query.title }})</div>
                    <br />
                    <div class="info">
                        You are logged in to {{ $route.query.acronym }} ({{ $route.query.title }}).
                    </div>
                    <div class="info">
                        Use the links below to access {{ $route.query.acronym }}.
                    </div>
                </div>
            </el-col>
            <el-col :span="3" class="login-title" style="display: flex;align-items: center;justify-content: center;"
                size="small" @click="$router.back()">
                <el-button type="primary" :icon="ArrowLeftBold" circle plain></el-button>
            </el-col>
        </el-row>
        <div class="role-box">
            <div class="role-item" v-if="loginrole.hasChair || loginrole.hasSubreviewer">
                <div style="font-weight: 700;margin-bottom: 6px;">Reviewer</div>
                <div class="inner"  v-if="loginrole.hasChair">
                    <div class="round"></div>
                    <div class="text" @click="chairInner()">chair</div>
                </div>
                <div class="inner"  v-else-if="loginrole.hasSubreviewer">
                    <div class="round"></div>
                    <div class="text" @click="subreviewerInner()">subreviewer</div>
                </div>
            </div>
            <div class="role-item" v-if="loginrole.hasPaper">
                <div style="font-weight: 700;margin-bottom: 6px;">Author</div>
                <div class="inner">
                    <div class="round"></div>
                    <div class="text" @click="authorInner()">author</div>
                </div>
            </div>
            <div class="role-item" v-if="loginrole.hasAuProceedings || loginrole.hasMaProceedings">
                <div style="font-weight: 700;margin-bottom: 6px;">Proceedings</div>
                <div class="inner"  v-if="loginrole.hasAuProceedings">
                    <div class="round"></div>
                    <div class="text" @click="proceedingsInner()">proceedings author ({{ loginrole.acronym }})</div>
                </div>
                <div class="inner"  v-if="loginrole.hasMaProceedings" style="margin-top: 5px;">
                    <div class="round"></div>
                    <div class="text" @click="proceedingsInner()">proceedings manager ({{ loginrole.acronym }})</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useRoute,useRouter } from "vue-router";
import request from "../../network/request"
import { ArrowLeftBold } from '@element-plus/icons-vue'


const route = useRoute()
const router = useRouter()

// 登录角色
const loginrole = ref({})

onMounted(()=>{
    // 获取登录用户所拥有的角色
    request.get(`/conference/joinlist`).then((res) => {
        loginrole.value = res.data.find((item)=>item.cid == route.query.cid)
    })
})

// 以主席身份进入
const chairInner = () => {
    router.push(`/common/managepapers?cid=${route.query.cid}&acronym=${route.query.acronym}`)
}

// 以审稿人身份进入
const subreviewerInner = () => {
    router.push(`/common/managereview?cid=${route.query.cid}&acronym=${route.query.acronym}&title=${route.query.title}&subnum=${route.query.subnum}`)
}

// 以投稿人身份进入
const authorInner = () => {
    router.push(`/common/listpapers?cid=${route.query.cid}&acronym=${route.query.acronym}`)
}
// 录用出版人身份进入
const proceedingsInner = (index, row) => {
    router.push(`/common/proceedingspapers?cid=${route.query.cid}&acronym=${route.query.acronym}`)
}

</script>

<style lang="scss">
.conferencelogin-container {
    .login-title {
        background: #b7dffd3b;
        margin-bottom: 30px;
        padding: 20px 0;

        .desc-box {
            font-size: 16px;
            padding: 0 30px;

            .title {
                font-weight: 700;
                font-size: 20px;
                padding: 0;
                -webkit-background-clip: text;
                background-clip: text;
                background-image: linear-gradient(to right, rgb(28, 31, 32), rgb(3, 79, 129));
                color: transparent;
            }

            .info {
                padding: 0;
                font-size: 14px;
                margin-bottom: 5px;
            }
        }
    }

    .role-box {
        .role-item {
            margin-bottom: 23px;
            .inner{
                display: flex;
                align-items: center;
                font-size: 13px;
                padding-left: 15px;
                padding-top: 5px;
                .round {
                    height: 4px;
                    width: 4px;
                    background-color: #000;
                    border-radius: 50%;
                    margin-right: 10px;
                    margin-top: 3px;
                }
                .text{
                    text-decoration: underline;
                    cursor: pointer;
                    color: #2790dddb;
                }
            }
        }
    }
}
</style>